import axios from 'axios'

export const AdminAdoptionService = {
  fetchAdoptionList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/adoptionlist${queryParams}`)
    } else {
      return axios.get(`/api/v1/adoptionlist`)
    }
  },
  fetchCSVFile (queryParams, totalAdoptions) {
    if (queryParams && totalAdoptions) {
      return axios.get(`/api/v1/adoptionlist${queryParams}/${totalAdoptions}`)
    } else {
      return axios.get(`/api/v1/adoptionlist`)
    }
  },
  fetchMappedAdoptionList (adoptionLevel, adoptionLevelFor) {
    return axios.get(`/api/v1/mappedadoption/${adoptionLevel}/${adoptionLevelFor}`)
  },
  addAdoptionItem (data) {
    return axios.post(`/api/v1/addadoption`, JSON.stringify({
      adoptionLevel: data.adoptionLevel, // Adoption Type 1=State,2=County,3=Jurisdiction
      countryId: data.countryId, // Country Id
      stateId: data.stateId, // State Id
      jurisdictionId: data.jurisdictionId, // Can be null Depends on Adoption Type
      townshipId: data.townshipId, // Can be null Depends on Adoption Type
      countyId: data.countyId, // Can be null Depends on Adoption Type
      codeBookId: data.codeBookId, // Code Book Id
      customTitle: data.customTitle, // Custom Title Id(same as Code Book)
      userId: data.userId, // Logged in user ID
      effectiveDate: data.effectiveDate, // Effective Date
      adoptionLableId: data.adoptionLableId, // Adoption Lable Id
      adoptionStatus: data.adoptionStatus, // Adoption Status
      adoptionType: data.adoptionType // Adoption Type
    }))
  },
  editAdoptionItem (data) {
    return axios.post(`/api/v1/editadoption`, JSON.stringify({
      adoptionLevel: data.adoptionLevel, // Adoption Type 1=State,2=County,3=Jurisdiction
      countryId: data.countryId, // Country Id
      stateId: data.stateId, // State Id
      jurisdictionId: data.jurisdictionId, // Can be null Depends on Adoption Type
      townshipId: data.townshipId, // Can be null Depends on Adoption Type
      countyId: data.countyId, // Can be null Depends on Adoption Type
      codeBookId: data.codeBookId, // Code Book Id
      customTitle: data.customTitle, // Custom Title Id(same as Code Book)
      userId: data.userId, // Logged in user ID
      effectiveDate: data.effectiveDate, // Effective Date
      adoptionLableId: data.adoptionLableId, // Adoption Lable Id
      adoptionStatus: data.adoptionStatus, // Adoption Status
      adoptionType: data.adoptionType, // Adoption Type
      id: data.id
    }))
  },
  changeAdoptionStatusItems (data) {
    return axios.post(`/api/v1/bulkadoptionsstatusupdate`, JSON.stringify({
      adoptionIds: data.id, // Selected Adoption Ids
      adoptionStatus: data.status, // Adoption Status 1=Current,2=Past
      effectiveDate: data.effectiveDate, // Effective Date
      adoptionType: data.adoptionType, // Adoption Type
      userId: data.userId, // logged UserId
      adoptionLabel: data.adoptionLabel // Adoption Label
    }))
  },
  addBulkAdoptions (data) {
    return axios.post(`/api/v1/addbulkadoptions`, JSON.stringify({
      bookIds: data.bookIds,
      adoptionLabelIds: data.adoptionLabelIds,
      userId: data.userId,
      id: data.id,
      adoptionLevel: data.adoptionLevel,
      adoptionStatus: data.adoptionStatus,
      adoptionType: data.adoptionType,
      effectiveDate: data.effectiveDate
    }))
  },
  importAdoptionFile (data) {
    return axios.post(
      `/api/v1/importadoption`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  importICCAdoptionFile (data) {
    return axios.post(
      `/api/v1/importadoptioninfo`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  fetchProposedAdoptionList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/proposedadoptionlist${queryParams}`)
    } else {
      return axios.get(`/api/v1/proposedadoptionlist`)
    }
  },
  fetchAdoptionActivityReportList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/adoptionactivity${queryParams}`)
    } else {
      return axios.get(`/api/v1/adoptionactivity`)
    }
  },
  validateAdoptionItem (data) {
    return axios.delete(`/api/v1/deleteadoption`, { data: data })
  },
  deleteAdoptionItem (data) {
    return axios.delete(`/api/v1/deleteadoption`, { data: data })
  },
  fetchAdoptionDetails (id) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `id=${id}`
    }
    return axios.get(`/api/v1/adoption${queryParams}`)
  }
}
